// Meter-based constants for US measurement handling
export const INCHES_PER_FOOT = 12;
export const METERS_PER_FOOT = 0.3048;
export const METERS_PER_INCH = 0.0254;
export const SQ_METER_PER_SQ_FOOT = 0.09290304;

// Precision constants for UX consistency (visible numbers = visible totals)
export const SQ_FT_DISPLAY_DECIMALS = 4; // Round at line-item level for display
export const SQ_FT_STORAGE_DECIMALS = 6; // Required for lossless sq ft round-trip
export const MM_PER_INCH = 25.4;
export const MM_PER_FOOT = 304.8;
export const LINEAL_MM_DECIMAL_PLACES = 4;
export const LINEAL_FEET_STORAGE_DECIMALS = 6; // Required for lossless feet+inches round-trip

// Square-metre entry provenance (FAC-5925). Canonical storage stays metres;
// `mm` only records how the user typed the number in.
export const MM_PER_METRE = 1000;
export const SQM_MM_ENTRY_DECIMAL_PLACES = 3; // Max decimals a user may type in mm
export const SQM_METRE_STORAGE_DECIMALS = 6; // 3 mm decimals / 1000 needs 6 metre decimals

// Company setting key that decides which unit new square-metre drafts start in.
export const ENTER_SQM_DIMENSIONS_IN_MM = "ENTER_SQM_DIMENSIONS_IN_MM";
// Entry masks. Metres keep the long-standing 4 decimals; mm is capped at 3
// so the converted metre value still fits the 6-decimal purchase order columns.
export const SQM_METRE_INPUT_MASK = "9[9999999999][.9999]";
export const SQM_MM_INPUT_MASK = "9[9999999999][.999]";
